import { render, staticRenderFns } from "./select-image.vue?vue&type=template&id=67e4cb52&scoped=true&"
import script from "./select-image.vue?vue&type=script&lang=js&"
export * from "./select-image.vue?vue&type=script&lang=js&"
import style0 from "./select-image.vue?vue&type=style&index=0&id=67e4cb52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4cb52",
  null
  
)

export default component.exports